import { GUEST_LINKS_NAME_MAX_LENGTH, GUEST_LINKS_NAME_MIN_LENGTH, } from '@lucidlink/dto/validation';
import { translate } from '@lucidlink/uicore';
export const guestLinkNameValidationRules = () => [
    {
        errorCodes: ['guestLink.name.minLength', 'guestLink.name.maxLength'],
        label: translate('Must be at least {{GUEST_LINKS_NAME_MIN_LENGTH}} and no more than {{GUEST_LINKS_NAME_MAX_LENGTH}} characters long', { GUEST_LINKS_NAME_MIN_LENGTH, GUEST_LINKS_NAME_MAX_LENGTH }),
    },
];
